import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "../../../../axios/index";

// Context
import { UserContext } from "../../../Context/UserContextProvider";

// components
import ShowProfileModal from "../../DashboardFileManagement/CardDetail/ShowProfileModal";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";
// import DatePicker from 'react-multi-date-picker';
// import persian from "react-date-object/calendars/persian";
// import persian_fa from "react-date-object/locales/persian_fa";
import { useLocation } from "react-router-dom";

// Styles
import styles from "./../UserManagment.module.css";
import Dstyles from "./../../DashboardFileManagement/DashboardFileManagement.module.css";

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";
import editIconBlue from "./../../../../assets/img/DashboardICons/editIconBlue.svg";
import UserManagmentRecordsAds from "./UserManagmentRecordsAds";
// import UserManagmentRecordsFiles from './UserManagmentRecordsFiles';
import ModalEditForm from "./ModalEditForm";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const UserManagmentInfoDetail = () => {
  const { userToken, permissions } = useContext(UserContext);
  const { state } = useLocation();
  const [modalShow, setModalShow] = useState(false);
  const [modalEditFormShow, setModalEditFormShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  // const [formBirthDate, setFormBirthDate] = useState(new Date("1987", "11", "23"));
  // const [formRegistryDate, setFormRegistryDate] = useState(new Date("2022", "07", "14"));
  const [formUserManagmentInfo, setFormUserManagmentInfo] = useState({
    id: "",
    name: "",
    fullName: "",
    family: "",
    numberId: "",
    callNumber: "",
    email: "",
    joinDate: "",
    isActive: true,
    isShowEstates: true,
  });
  const [recordAdsData, setRecordAdsData] = useState([]);

  // const [filterRecords, setFilterRecords] = useState({
  //     ads: true,
  //     files: false
  // })

  // const changeFilterRecordsHandler = (name) => {
  //     if (name === "ads") {
  //         setFilterRecords((prev) => {
  //             return { ...prev, ads: true, files: false };
  //         });
  //     } else if (name === "files") {
  //         setFilterRecords((prev) => {
  //             return { ...prev, files: true, ads: false };
  //         });
  //     }
  // }

  const formUserManagmentChangeHandler = e => {
    setFormUserManagmentInfo({
      ...formUserManagmentInfo,
      [e.target.name]: e.target.value,
    });
  };

  // const formBirthDateChangeHandler = (value) => {
  //     setFormBirthDate(value);
  // }
  // const formRegistryDateChangeHandler = (value) => {
  //     setFormRegistryDate(value);
  // }

  useMemo(() => formUserManagmentInfo, [formUserManagmentInfo]);
  useMemo(() => recordAdsData, [recordAdsData]);

  useEffect(() => {
    const dataHandler = async () => {
      // setIsLoading(true)

      const getUser = await axios.get(`Users/${state.id}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      const user = getUser.data.data;
      setFormUserManagmentInfo(prev => {
        return {
          ...prev,
          id: state.id,
          fullName: user.fullName,
          name: user.name,
          family: user.family,
          callNumber: user.phoneNumber,
          email: user.email,
          joinDate: user?.createDate,
          isActive: user?.isActive,
          isShowEstates: user?.isShowEstates,
        };
      });
      // console.log(user)
      setRecordAdsData(user.estates.data);
      // setFormBirthDate(user.creationDate)
      setIsLoading(false);
    };

    dataHandler();
  }, [state.id, userToken]);

  return (
    <>
      <style>
        {`
                    .rmdp-input {
                        color: #363636;
                        font-size: 16px;
                        border: 1px solid #e1e1e1;
                        border-radius: 100px;
                        height: auto;
                        padding: 11px 15px;
                        box-sizing: border-box;
                        transition: all 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                        box-shadow: none;
                        width: 100%;
                    }
                    .rmdp-input:focus {
                        border-color: #21409a;
                        box-shadow: none;
                    }
                    .rmdp-wrapper {
                        width: 100% !important;
                        box-shadow: none !important;
                        border: 1px solid #e1e1e1;
                        border-radius: 24px;
                    }
                    .rmdp-wrapper input {
                        font-size: 24px !important;
                        width: 45px !important;
                        color: #363636 !important;
                    }
                    .dvdr{
                        font-size: 35px !important;
                        color: #D9D9D9 !important;
                    }
                    `}
      </style>

      <ModalEditForm
        show={modalEditFormShow}
        onHide={() => setModalEditFormShow(false)}
        id={state.id}
        state={state}
        formUserManagmentInfo={formUserManagmentInfo}
        setFormUserManagmentInfo={setFormUserManagmentInfo}
        formUserManagmentChangeHandler={formUserManagmentChangeHandler}
        // formBirthDate={formBirthDate}
        // setFormBirthDate={setFormBirthDate}
        // formRegistryDate={formRegistryDate}
        // setFormRegistryDate={setFormRegistryDate}
        avatarName={state?.avatarName}
      />

      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <div className={`my-3 px-0 pb-4 ${styles.file_cards_container}`}>
                <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2" dir="rtl">
                  <div className="d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2">
                    <a href="#" onClick={history.goBack}>
                      <img className="ms-2" src={arrowIcon} alt="icon" />
                    </a>
                    <div className={styles.text1}>{formUserManagmentInfo.name + " " + formUserManagmentInfo.family}</div>
                  </div>

                  {/* <div className='d-flex align-items-center justify-content-end flex-wrap mt-2 mb-2' role="button">
                                            <Link to={`/user-managment-chat-detail/1`} className={styles.link_icon_text}>
                                                <Link to={`/user-managment-chat/${formUserManagmentInfo.id}`} className={styles.link_icon_text}>
                                                شروع چت
                                            </Link>
                                        </div> */}
                </div>

                {/* User Managment Info Details */}

                <div dir="rtl" className={`text-right mx-4 px-4 ${styles.total_user_managment_detail_box}`}>
                  <div className={`pb-5`}>
                    <img
                      className={`${styles.image_user_managment_detail}`}
                      loading="lazy"
                      src={`https://backdev.azrmelk.com/images/users/avatar/${state?.avatarName}`}
                      alt="user-profile"
                    />

                    <div className={`d-flex justify-content-between align-items-start flex-wrap mt-4 mb-2 pt-4 pb-1`}>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="fullName">
                          {" "}
                          نام و نام‌خانوادگی{" "}
                        </Form.Label>
                        <Form.Control
                          className={`${styles.form_control_input} shadow-none`}
                          type="text"
                          id="fullName"
                          name="fullName"
                          value={formUserManagmentInfo.fullName}
                        />
                      </Form.Group>
                      {/* <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                                                    <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="birthDate"> تاریخ تولد </Form.Label>
                                                    <DatePicker
                                                        id="birthDate"
                                                        value={formBirthDate}
                                                        calendar={persian}
                                                        locale={persian_fa}
                                                        format="YYYY-MM-DD"
                                                    />
                                                </Form.Group> */}
                      {/* <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                                                    <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="callNumber"> تاریخ تولد </Form.Label>
                                                    <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" id="birthDate" name="birthDate" value={formUserManagmentInfo.birthDate} />
                                                </Form.Group> */}
                      {/* <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                                                    <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="numberId"> شماره شناسنامه </Form.Label>
                                                    <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" id="numberId" name="numberId" value={formUserManagmentInfo.numberId} />
                                                </Form.Group> */}
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="callNumber">
                          {" "}
                          شماره تماس{" "}
                        </Form.Label>
                        <Form.Control
                          className={`${styles.form_control_input} shadow-none`}
                          type="tel"
                          id="callNumber"
                          name="callNumber"
                          value={formUserManagmentInfo.callNumber}
                        />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="callNumber">
                          {" "}
                          تاریخ عضویت{" "}
                        </Form.Label>
                        <Form.Control
                          className={`${styles.form_control_input} shadow-none`}
                          type="text"
                          id="registryDate"
                          name="registryDate"
                          value={formUserManagmentInfo.joinDate}
                        />
                      </Form.Group>
                      {/* <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                                                    <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="registryDate"> تاریخ عضویت </Form.Label>
                                                    <DatePicker
                                                        id="registryDate"
                                                        value={formRegistryDate}
                                                        onChange={formRegistryDateChangeHandler}
                                                        calendar={persian}
                                                        locale={persian_fa}
                                                        format="YYYY-MM-DD"
                                                    />
                                                </Form.Group> */}
                    </div>

                    {permissions?.find(item => item === 15) === 15 && (
                      <div
                        className={`text-center d-flex justify-content-center align-items-center me-auto ${styles.total_edit_btn}`}
                        role="button"
                        onClick={() => setModalEditFormShow(true)}>
                        <img className={`ps-2 ms-1`} src={editIconBlue} alt="edit-form-icon" width={`25`} />
                        <button style={{ color: "#21409a" }} className={`border-0 bg-transparent`}>
                          ویرایش
                        </button>
                      </div>
                    )}
                  </div>

                  {/* User Managment Records */}

                  <div className={`mt-5 pb-4`}>
                    {/* <div className={`d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2 pb-2 ${styles.text1}`}>
                                                سوابق
                                            </div> */}

                    <div dir="rtl" className={`d-flex align-items-center justify-content-start mt-4 mb-2 ms-auto ${styles.total_filter_record_box}`}>
                      <div className={`px-4 ${styles.ads_filter_box} ${styles.filter_record_box_active}`} role="button">
                        {/* onClick={() => changeFilterRecordsHandler("ads")} */}
                        فایل ها
                      </div>
                      {/* <div className={`px-4 ${styles.files_filter_box} ${filterRecords.files ? styles.filter_record_box_active : styles.filter_record_box_deactive}`} onClick={() => changeFilterRecordsHandler("files")} role="button">
                                                    فایل ها
                                                </div> */}
                    </div>
                  </div>

                  <UserManagmentRecordsAds recordAdsData={recordAdsData} />
                  {/* {filterRecords.ads && <UserManagmentRecordsAds recordAdsData={recordAdsData} />} */}
                  {/* {filterRecords.files && <UserManagmentRecordsFiles />} */}
                </div>
              </div>
            </div>
            <div className="col-md-3">
              {/* sideMenu starts */}
              <DashboardSideMenu manageUsers manageUsersInfo />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserManagmentInfoDetail;
